import apiResponse from '@stores/ApiResponse';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';
import { PledgeStore } from '@app/api/PledgeStore';

export type CohortPledgeView = {
  id: number;
  cohortId: number;
  amount: number;
  individualAmount: number;
  externalAmount: number;
  min: number;
  max: number;
  finalized: boolean;
};

export class CohortPledgeViewCreator {
  constructor(private readonly store: PledgeStore = new PledgeStore()) {}

  async createView(groupId: number) {
    const result = await apiResponse.handleApiResponse<CohortPledgeView>(
      async () => await this.store.getCohortPledge(groupId)
    );

    return {
      id: result.id,
      cohortId: result.cohortId,
      amount: result.amount,
      individualAmount: result.individualAmount,
      externalAmount: result.externalAmount,
      min: result.min,
      max: result.max,
      finalized: result.finalized,
    } as CohortPledgeView;
  }
}

export const useCohortPledgeViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [CohortPledgeViewCreator.name, groupId],
    queryFn: () => new CohortPledgeViewCreator().createView(groupId),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
    enabled: groupId > 0,
  });
